import React, { createContext, useReducer } from "react"
import AppReducer from "./AppReducer"

// Initial state
const initialState = {
  bagItems: [
    // { id: 1, title: "Flower", amount: 20 },
    // { id: 2, title: "Something", amount: 5 },
  ],
}

// Create context
export const GlobalContext = createContext(initialState)

// Provider component
export const GlobalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AppReducer, initialState)

  // Actions
  function addToBag(bagItem) {
    dispatch({
      type: "ADD_TO_BAG",
      payload: bagItem,
    })
  }

  function removeFromBag(id) {
    dispatch({
      type: "REMOVE_FROM_BAG",
      payload: id,
    })
  }

  return (
    <GlobalContext.Provider
      value={{ bagItems: state.bagItems, addToBag, removeFromBag }}
    >
      {children}
    </GlobalContext.Provider>
  )
}
